import {takeEvery} from 'redux-saga/effects'
import {GET_BIOMETRIC_LOGS} from 'setup/redux/Actions/BiometricLog/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_BIOMETRIC_LOGS, fetchData)
}

export default dataSaga
